var _circle, _circle2, _circle3, _circle4, _line, _line2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegisteredModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 20,
    r: 2,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 7,
    r: 2,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 4,
    r: 2,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 15,
    r: 2,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.05132,
    y1: 18.3162,
    x2: 5.05132,
    y2: 9.31623,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 5.77514,
    y1: 7.02561,
    x2: 18.7751,
    y2: 4.02561,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 19.0101,
    y1: 12.8586,
    x2: 20.01,
    y2: 5.85858,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.5528,
    y1: 19.1056,
    x2: 17.5528,
    y2: 16.1056,
    stroke: "#2374bb",
    strokeWidth: 2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 17.5528,
    y1: 13.8944,
    x2: 5.55279,
    y2: 7.89443,
    stroke: "#2374bb",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisteredModel);
export default __webpack_public_path__ + "static/media/registered-model.24429a4f6158e57b01b3928e2605aa25.svg";
export { ForwardRef as ReactComponent };